<template>
  <section class="app-footer">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © {{ new Date().getFullYear() }} <a href="/" target="_blank" class="text-gray-800 text-hover-primary">believe</a></span>
        <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Designed & Developed by
  <a href="https://www.anideos.com/" target="_blank"> Anideos</a></span>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>
